import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Product } from "@/components/Product";
import { Capabilities } from "@/components/Capabilities";
import { OnSite } from "@/components/OnSite";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <Product />
        <Capabilities />
        <OnSite />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
